import config from "./../../common/config";
const data = [
  {
    id: 0,
    name: "home",
    transKey:
      config.trans && config.trans.menuHome ? config.trans.menuHome : "Home",
    titleTransKey: "homeTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.home,
    linkMenu: config.enumStaticUrls.home,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: false,
  },

  {
    id: 1,
    name: "leaderboard",
    transKey:
      config.trans && config.trans.menuLeaderboard
        ? config.trans.menuLeaderboard
        : "Leaderboard",
    titleTransKey: "leaderboardTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.leaderboard,
    linkMenu: config.enumStaticUrls.leaderboard,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: false,
  },

  {
    id: 2,
    name: "answers",
    transKey:
      config.trans && config.trans.menuAnswers
        ? config.trans.menuAnswers
        : "Answers",
    titleTransKey: "answerTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.answers,
    linkMenu: config.enumStaticUrls.answers,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: false,
  },
  {
    id: 3,
    name: "rules",
    transKey:
      config.trans && config.trans.menuRules ? config.trans.menuRules : "Rules",
    titleTransKey: "rulesTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.rules,
    linkMenu: config.enumStaticUrls.rules,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: false,
  },

  {
    id: 4,
    name: "menuTerms",
    transKey:
      config.trans && config.trans.menuRulesAndTerms
        ? config.trans.menuRulesAndTerms
        : "Terms",
    titleTransKey: "termsTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.terms,
    linkMenu: config.enumStaticUrls.terms,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: false,
  },
];
export default data;
